import React from 'react'

function OrangeGradient() {
  return (
    <svg width="444" height="344" viewBox="0 0 444 344" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_f_297_2)">
      <ellipse cx="222" cy="172" rx="150" ry="100" fill="url(#paint0_linear_297_2)"/>
      </g>
      <defs>
      <filter id="filter0_f_297_2" x="0.0742493" y="0.0742493" width="443.852" height="343.852" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="35.9629" result="effect1_foregroundBlur_297_2"/>
      </filter>
      <linearGradient id="paint0_linear_297_2" x1="36" y1="115" x2="634.319" y2="230.695" gradientUnits="userSpaceOnUse">
      <stop stopColor="#8A2BE2"/>
      <stop offset="0.5" stopColor="#FFA500"/>
      <stop offset="1" stopColor="#F8F8FF"/>
      </linearGradient>
      </defs>
    </svg>
  )
}

export default OrangeGradient